module.exports=require('../../decode-ranges.js')('irAx9rABBBAYAw3HAAADABAOACA')